import { useFont } from '@octane/spark'
import styled, { css } from 'styled-components'

export const DropdownWrapper = styled.div`
    position: relative;

    /* Override Spark Dropdown's inline-block to allow full width */
    > div {
        display: block;
        width: 100%;
    }
`

export const NoWrap = styled.div<{ isPlaceholder?: boolean }>`
    white-space: nowrap;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    user-select: none;

    ${({ isPlaceholder }) =>
        isPlaceholder
            ? css`
                  ${() => useFont('c16', { italic: true, weight: '400' })}
                  color: ${({ theme }) => theme.colors.monochrome.graphite};
              `
            : css`
                  font-weight: bold;
                  color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
              `}
`

export const Item = styled.div`
    padding: 0.7em;
    padding-bottom: 0.3em;
`

export const ButtonInner = styled.div`
    display: grid;
    grid-template-columns: 1fr 3em;
    align-items: center;
    width: 100%;
    gap: 10px;
`

export const RightAligned = styled.div`
    justify-self: right;
`

export const StyledButton = styled.button<{
    error?: boolean
}>`
    background-color: ${({ theme }) => theme.colors.monochrome.white};
    border: 1px solid ${({ theme }) => theme.colors.monochrome.graphite};
    border-radius: 4px;
    color: ${({ theme }) => theme.colors.monochrome.jetlineBlack};
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 15px 12px;
    width: 100%;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    position: relative;
    box-sizing: border-box;
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;

    &:hover:not(:disabled) {
        border-color: ${({ theme }) => theme.colors.brand.primary};
    }

    &:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
        box-shadow:
            0 0 0 2px ${({ theme }) => theme.colors.monochrome.white},
            0 0 0 4px ${({ theme }) => theme.colors.brand.primary};
    }

    &:disabled {
        border-color: ${({ theme }) => theme.states.disabled.light.value};
        color: ${({ theme }) => theme.states.disabled.dark.color};
        cursor: not-allowed;
        opacity: 0.6;
    }

    ${({ error, theme }) =>
        error &&
        css`
            border-color: ${theme.colors.alert.warning};
            color: ${theme.colors.alert.warning};
        `}
`
